import { useParams } from "react-router";
import { Loading } from "./Loading";
import { NotFound } from "./NotFound";
import { useContent } from "@hooks/useContent";
import { isPageAllowedForLocale } from "@utils/localeRestrictions";
import { BlogPage } from "./BlogPage";
import { GetBlogPageBySlug } from "@queries/GetBlogPageBySlug";
import { useGlobalContext } from "@utils/GlobalContext";
import { useScrollReset } from "@hooks/useScrollReset";

export const BlogPageResolver = () => {
  const { slug } = useParams();
  const { locale } = useGlobalContext();

  const [response] = useContent({
    query: GetBlogPageBySlug,
    variables: { slug: slug ?? "" },
  });

  useScrollReset();

  if (response.fetching) {
    return <Loading />;
  }

  const [blogPage] = response.data?.post?.items ?? [];
  const blogFeed = response.data?.feed?.items ?? [];
  const isAllowedByMarkets = isPageAllowedForLocale(locale, blogPage?.showPageInLocales as string[] | undefined ?? []);

  if (!response.data || !slug || !blogPage || !isAllowedByMarkets) {
    return <NotFound />;
  }

  return <BlogPage key={slug} page={blogPage!} blogFeed={blogFeed} />;
};
